import type { DialoguePool } from '@/state/types';

export const L21_DIALOGUE: DialoguePool = {
  slowPlay: [
    "Is the pebble too heavy? Do you want a little 'pebble-lifting' glove?",
    "Everyone's watching you not move the rocks. They think you're the 'Doesn't Move Rocks' guy now.",
    "The pebbles are, technically, pebbles. The bins are, technically, bins. I've done my part.",
  ],
  tokenLoss: [
    "You've misplaced a token. Somewhere near the pebble, I should think. Check under it.",
    "A pebble took a token. I didn't think they had the strength. Humbling, really.",
    'That was, not a sort. That was a flail. Participation trophy recycled. I have more.',
  ],
  solution: [
    "Five pebbles, somewhere. Either bin. Both bins. Frankly, a colander would've done.",
    'Emotional weight: measured. Accuracy: irrelevant. You got there.',
    'I sighed. Audibly. The door is open because my sigh pushed it.',
  ],
  spite: [
    'The pebbles again. You know, they weigh slightly less the second time. Psychologically speaking. I didn\u2019t account for that.',
  ],
};
